import * as Yup from "yup";

export type platform = {
  searchName: string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const platformInitialValues = {
  searchName: "",
  created_at: [null, null],
  updated_at: [null, null],
};

export const platformMandatoryFields = [];

export const platformValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const platformProperties = [
  {
    id: "searchName",
    type: "text",
    label: "Platform Name",
    Placeholder: "Enter Platform Name",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj:any, keys:any[]) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
